import { showConfirm } from "@erp/shared/utils/dialog";
/**
 * @description
 * 파일 입력들을 순회한 뒤, 빈 항목들을 추출하여 확인 창을 띄움
 * 사용자가 취소하면 false 반환
 * @param fileInputs
 */
export const confirmFileInput = async (fileInputs) => {
    const fileLabels = [];
    for (const f of fileInputs) {
        if (!f.value) {
            fileLabels.push(f.label);
        }
    }
    const ok = await showConfirm(`${fileLabels.join(", ")}를 첨부하지 않았습니다. 계속 진행 하시겠습니까?`, "확인", false, "예", "아니오");
    return !!ok;
};
/**
 * @description 확인자와 승인자 선택 체킹, 없다면 에러 반환
 * @param memberInfo
 */
export const checkMemberInfo = (memberInfo) => {
    if (!memberInfo[1].id) {
        throw new Error("확인자, 승인자를 선택하여 주십시오.");
    }
};
/**
 * @description 재료비 항목의 존재 여부와 단가 입력 여부 체킹, 없다면 에러 반환
 * @param productCost
 */
export const checkProductCost = (productCost) => {
    if (productCost?.belong_data?.length === 0) {
        throw new Error("재료비 항목이 없습니다.");
    }
    productCost?.belong_data?.[0]?.belong_data?.forEach((item) => {
        if (!item.cost_unit_price) {
            throw new Error("재료비 단가를 입력하여 주십시오.");
        }
    });
};
/**
 * @description 노무비 항목 체킹, 없다면 에러 반환
 * @param directLabor
 */
export const checkDirectLabor = (directLabor) => {
    if (directLabor?.belong_data?.length === 0) {
        throw new Error("직접 노무비를 산출해야 합니다.");
    }
};
/**
 * @description 텍스트 필드 rules 체킹, 값이 없다면 에러 반환
 * @param formValidate
 * @param message
 */
export const checkFormValidate = (formValidate, message) => {
    if (!formValidate) {
        throw new Error(`${message ?? ""} 정보를 정확히 입력하여 주십시오.`);
    }
};
export const checkInhouseBidNumber = (inhouseBidNumber) => {
    if (!inhouseBidNumber || inhouseBidNumber === "") {
        throw new Error("수주서 작성 시 견적서를 불러와야 합니다.");
    }
};
// export const checkEmptyBOMList = (BOMList: BOM[]): void => {
//   if (BOMList.length === 0) {
//     throw new Error("BOM 리스트가 비어있습니다.");
//   }
// };
export const confirmMaterial = async () => {
    const ok = await showConfirm("산출내역서를 모두 확인하셨습니까?", "확인", false, "예", "아니오");
    return !!ok;
};
export const confirmDirectInput = async () => {
    const ok = await showConfirm("직접 입력한 산출내역서를 모두 확인하셨습니까?", "확인", false, "예", "아니오");
    return !!ok;
};
export const confirmBOMList = async () => {
    const ok = await showConfirm("BOM 목록을 모두 확인하셨습니까?", "확인", false, "예", "아니오");
    return !!ok;
};
// XXX: 위 검증, 확인 로직을 탭 별로 분류함
export const validateBasicInfo = async (estimateMemberInfo, basicInfoValidate, filesInputs) => {
    checkMemberInfo(estimateMemberInfo);
    checkFormValidate(basicInfoValidate, "기본");
    return await confirmFileInput(filesInputs);
};
export const validateDirectInput = async (directInputValidate) => {
    checkFormValidate(directInputValidate, "산출내역서");
    return await confirmDirectInput();
};
export const validateCalcCost = async (calcCostDetailData) => {
    checkProductCost(calcCostDetailData[0]);
    checkDirectLabor(calcCostDetailData[1]);
    return await confirmMaterial();
};
export const validateBOMList = async () => {
    return await confirmBOMList();
};
